// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";
// import Spinner from "../common/Spinner";
// import { FiSend, FiPaperclip, FiX, FiCheckCircle } from "react-icons/fi";
// import "./SendMessage.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const SendMessage = () => {
//   const [senderEmail, setSenderEmail] = useState("");
//   const [subject, setSubject] = useState("");
//   const [message, setMessage] = useState("");
//   const [files, setFiles] = useState([]);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           throw new Error("No authentication token found");
//         }

//         const response = await fetch(`${BASE_URL}/api/employees`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.message || "Failed to fetch employee data");
//         }

//         const data = await response.json();
//         const employeeData = data.map((employee) => ({
//           value: employee.email,
//           label: `${employee.name} (${employee.email})`,
//         }));

//         const allOption = {
//           value: "all",
//           label: "Select All",
//         };

//         setEmployeeOptions([allOption, ...employeeData]);
//       } catch (err) {
//         console.error("Error fetching employee data:", err);
//         setError(err.message || "Failed to fetch employee data");
//       }
//     };

//     fetchEmployees();
//   }, []);

//   const handleEmployeeSelect = (selectedOptions) => {
//     if (selectedOptions.some((option) => option.value === "all")) {
//       setSelectedEmployees(
//         employeeOptions.filter((option) => option.value !== "all")
//       );
//     } else {
//       setSelectedEmployees(selectedOptions);
//     }
//   };

//   const handleFileChange = (e) => {
//     setFiles([...e.target.files]);
//   };

//   const removeFile = (index) => {
//     const newFiles = [...files];
//     newFiles.splice(index, 1);
//     setFiles(newFiles);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccessMessage("");
//     setLoading(true);

//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("Authentication token not found");
//         setLoading(false);
//         return;
//       }

//       const receiverEmails = selectedEmployees.map(
//         (employee) => employee.value
//       );
//       if (receiverEmails.length === 0) {
//         setError("Please select at least one receiver email");
//         setLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("subject", subject);
//       formData.append("message", message);
//       receiverEmails.forEach((email) =>
//         formData.append("receiverEmail", email)
//       );
//       files.forEach((file) => formData.append("files", file));

//       const response = await fetch(`${BASE_URL}/api/mailmessage/sendMessage`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to send the message");
//       }

//       setSuccessMessage("Email sent successfully with attachments");
//       setSubject("");
//       setMessage("");
//       setFiles([]);
//       setSelectedEmployees([]);

//       setTimeout(() => {
//         setSuccessMessage("");
//       }, 5000);
//     } catch (err) {
//       setError(err.message || "Failed to send the message");
//     } finally {
//       setLoading(false);
//     }
//   };


//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   return (
//     <div className="send-message-page">
//       <Navbar toggleSidebar={toggleSidebar} />
//       <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

// <div className="send-message-container">
//   <div className="send-message-card">
//     <div className="card-header">
//       <h2>
//         <FiSend className="icon" /> Compose New Message
//       </h2>
//     </div>

//     <form onSubmit={handleSubmit} className="send-message-form">
//       <div className="form-group">
//         <label htmlFor="receiverEmail">To:</label>
//         <Select
//           isMulti
//           value={selectedEmployees}
//           onChange={handleEmployeeSelect}
//           options={employeeOptions}
//           placeholder="Select recipients..."
//           className="employee-select-dropdown"
//           classNamePrefix="select"
//           noOptionsMessage={() => "No employees found"}
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="subject">Subject:</label>
//         <input
//           type="text"
//           id="subject"
//           value={subject}
//           onChange={(e) => setSubject(e.target.value)}
//           required
//           placeholder="What's this about?"
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="message">Message:</label>
//         <textarea
//           id="message"
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//           required
//           placeholder="Write your message here..."
//           rows="8"
//         />
//       </div>

//       <div className="form-group file-upload-container">
//         <label htmlFor="fileUpload" className="file-upload-label">
//           <FiPaperclip className="icon" /> Attach Files
//           <input
//             type="file"
//             id="fileUpload"
//             multiple
//             onChange={handleFileChange}
//             className="file-upload-input"
//           />
//         </label>

//         {files.length > 0 && (
//           <div className="file-preview-container">
//             {files.map((file, index) => (
//               <div key={index} className="file-preview">
//                 <span>{file.name}</span>
//                 <button
//                   type="button"
//                   onClick={() => removeFile(index)}
//                   className="remove-file-btn"
//                 >
//                   <FiX />
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       <div className="form-actions">
//         <button type="submit" className="send-button" disabled={loading}>
//           {loading ? (
//             <Spinner size="small" />
//           ) : (
//             <>
//               <FiSend className="icon" /> Send Message
//             </>
//           )}
//         </button>
//       </div>

//       {/* {error && (
//               <div className="alert error">
//                 <FiX className="icon" /> {error}
//               </div>
//             )} */}


//       {error && (
//         <div className="alert success">
//           <FiCheckCircle className="icon" /> Message sent successfully!
//         </div>
//       )}

//       {successMessage && (
//         <div className="alert success">
//           <FiCheckCircle className="icon" /> {successMessage}
//         </div>
//       )}
//     </form>
//   </div>
// </div>

//       <Footer />
//     </div>
//   );
// };

// export default SendMessage;


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////











// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";
// import Spinner from "../common/Spinner";
// import { FaPaperPlane } from "react-icons/fa";
// import {
//   FiSend,
//   FiPaperclip,
//   FiX,
//   FiCheckCircle,
//   FiUsers,
//   FiType,
//   FiMessageSquare
// } from "react-icons/fi";
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Alert,
//   IconButton,
//   CircularProgress
// } from "@mui/material";
// import { FaUserFriends, FaHeading, FaRegCommentDots } from "react-icons/fa";
// import composemail from '../../Assets/emailcompose.png'

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const SendMessage = () => {
//   const [subject, setSubject] = useState("");
//   const [message, setMessage] = useState("");
//   const [files, setFiles] = useState([]);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) throw new Error("No authentication token found");

//         const response = await fetch(`${BASE_URL}/api/employees`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         if (!response.ok) {
//           const errData = await response.json();
//           throw new Error(errData.message || "Failed to fetch employee data");
//         }

//         const data = await response.json();
//         const employeeData = data.map((emp) => ({
//           value: emp.email,
//           label: `${emp.name} (${emp.email})`,
//         }));

//         const allOption = { value: "all", label: "Select All" };
//         setEmployeeOptions([allOption, ...employeeData]);
//       } catch (err) {
//         setError(err.message || "Failed to fetch employee data");
//       }
//     };

//     fetchEmployees();
//   }, []);

//   const handleEmployeeSelect = (selected) => {
//     if (selected.some((opt) => opt.value === "all")) {
//       setSelectedEmployees(
//         employeeOptions.filter((opt) => opt.value !== "all")
//       );
//     } else {
//       setSelectedEmployees(selected);
//     }
//   };

//   const handleFileChange = (e) => {
//     setFiles([...e.target.files]);
//   };

//   const removeFile = (index) => {
//     setFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccessMessage("");
//     setLoading(true);

//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) throw new Error("Authentication token not found");

//       const receiverEmails = selectedEmployees.map((emp) => emp.value);
//       if (receiverEmails.length === 0)
//         throw new Error("Please select at least one receiver email");

//       const formData = new FormData();
//       formData.append("subject", subject);
//       formData.append("message", message);
//       receiverEmails.forEach((email) => formData.append("receiverEmail", email));
//       files.forEach((file) => formData.append("files", file));

//       // Log formData contents for debugging
//       for (let [key, value] of formData.entries()) {
//         console.log(key, value);
//       }

//       const response = await fetch(`${BASE_URL}/api/mailmessage/sendMessage`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errData = await response.json();
//         throw new Error(errData.message || "Failed to send the message");
//       }

//       setSuccessMessage("Email sent successfully with attachments");
//       setSubject("");
//       setMessage("");
//       setFiles([]);
//       setSelectedEmployees([]);
//       setTimeout(() => setSuccessMessage(""), 5000);
//     } catch (err) {
//       console.error("Error sending message:", err);
//       setError(err.message || "Failed to send the message");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

//   const IconWrapper = ({ children }) => (
//     <Box
//       sx={{
//         p: 0.5,
//         border: "1px solid black",
//         borderRadius: "50%",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         minWidth: 32,
//         minHeight: 32
//       }}
//     >
//       {children}
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "#f5f7fa" }}>
//       <Navbar toggleSidebar={toggleSidebar} />
//       <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

//       {/* Header */}
//       <Box sx={{ p: 3, mt: 6, ml: { md: "240px", xs: "10px" } }}>
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           Compose Mail
//         </Typography>
//         <Typography variant="subtitle1" color="text.secondary">
//           Draft and send messages to employees with attachments and formatting.
//         </Typography>
//       </Box>

//       {/* Main Content with Two Sections */}
//       <Box
//         sx={{
//           flex: 1,
//           display: "flex",
//           // flexDirection: { xs: "column", md: "row" },
//           flexDirection: { xs: "column-reverse", md: "row" },
//           gap: { xs: 3, md: 0 }, // <-- add gap of 3 (theme spacing) on mobile, no gap on desktop
//           p: 3.5,
//           mt: 0,
//           mb: 20,
//           pl: { md: 33 }
//         }}
//       >
//         {/* Left Side (40%) */}
//         <Box
//           sx={{
//             flex: "0 0 40%",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "flex-start",
//             textAlign: "center",
//             p: 3,
//             pt: 2,
//             alignSelf: "flex-start",
//             minHeight: 540,
//             borderRadius: "16px",
//             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
//             bgcolor: "#ffffff",
//             width: { xs: "100%", sm: "auto" }, // <-- here is the change
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               mb: 10,
//               mt: 0 // optional: small top margin so it's not too close to the edge
//             }}
//           >
//             Inbox Mail
//           </Typography>

//           <Box
//             component="img"
//             src={composemail}
//             alt="Mail Illustration"
//             sx={{
//               maxWidth: 190,
//               height: "auto",
//               mb: 11
//             }}
//           />

//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{ maxWidth: 240, mb: 4, fontWeight: 600 }}
//           >

//             View and manage your inbox messages quickly and efficiently.
//           </Typography>


//           <button
//             type="button"
//             style={{
//               backgroundColor: "#4fc3f7", // light blue
//               color: "#fff",
//               border: "none",
//               padding: "10px 20px",
//               fontSize: "15px",
//               fontWeight: "600",
//               fontFamily: "'Poppins', sans-serif",
//               borderRadius: "8px",
//               cursor: "pointer",
//               overflow: "hidden",
//               position: "relative",
//               transition: "all 0.3s ease",
//               boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
//             }}
//             // import MyMessages from './components/Messages/MyMessages';    //d
//             onClick={() => navigate("/MyMessages")}
//             onMouseOver={(e) => {
//               e.currentTarget.style.backgroundColor = "#0288d1"; // darker blue
//               e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
//               const wave = e.currentTarget.querySelector(".hover-wave");
//               if (wave) wave.style.left = "100%";
//             }}
//             onMouseOut={(e) => {
//               e.currentTarget.style.backgroundColor = "#4fc3f7"; // revert to light blue
//               e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
//               const wave = e.currentTarget.querySelector(".hover-wave");
//               if (wave) wave.style.left = "-100%";
//             }}
//           >
//             Inbox
//             <span
//               className="hover-wave"
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: "-100%",
//                 width: "100%",
//                 height: "100%",
//                 background: "rgba(255, 255, 255, 0.15)",
//                 transform: "skewX(-20deg)",
//                 transition: "left 0.6s ease-in-out",
//                 pointerEvents: "none",
//               }}
//             />
//           </button>
//         </Box>




//         {/* Right Side (60%) - Your Current Compose Form */}
//         <Box sx={{ flex: "0 0 60%", pl: { md: 3, xs: 0 }, mt: { xs: 2, md: 0 }, }}>
//           <div className="send-message-container">
//             <div className="send-message-card">
//               <Box
//                 sx={{
//                   p: 1.5,
//                   borderBottom: "1px solid #e0e0e0",
//                   bgcolor: "#f5f5f5",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1
//                 }}
//               >
//                 <Typography
//                   variant="subtitle1"
//                   sx={{
//                     fontWeight: 600,
//                     fontSize: "1rem",
//                     color: "#333",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px"
//                   }}
//                 >
//                   Compose New Message
//                   <Box
//                     sx={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       width: 22,
//                       height: 22,
//                       border: "2px solid black", // black border
//                       borderRadius: "50%",
//                       backgroundColor: "transparent", // no background
//                       color: "black", // black icon
//                       padding: "2px"
//                     }}
//                   >
//                     <FaPaperPlane size={12} />
//                   </Box>
//                 </Typography>
//               </Box>

//               <form onSubmit={handleSubmit} className="send-message-form">
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//                   <IconWrapper><FaUserFriends size={16} /></IconWrapper>
//                   <Box sx={{ flex: 1 }}>
//                     <Select
//                       isMulti
//                       value={selectedEmployees}
//                       onChange={handleEmployeeSelect}
//                       options={employeeOptions}
//                       placeholder="Recipients..."
//                       classNamePrefix="select"
//                       noOptionsMessage={() => "No employees found"}
//                     />
//                   </Box>
//                 </Box>

//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//                   <IconWrapper><FaHeading size={16} /></IconWrapper>
//                   <TextField
//                     variant="standard"
//                     fullWidth
//                     placeholder="Subject"
//                     value={subject}
//                     onChange={(e) => setSubject(e.target.value)}
//                   />
//                 </Box>


//                 <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }}>
//                   <IconWrapper><FaRegCommentDots size={16} /></IconWrapper>
//                   <TextField
//                     variant="standard"
//                     fullWidth
//                     multiline
//                     minRows={2}
//                     placeholder="Message..."
//                     value={message}
//                     onChange={(e) => setMessage(e.target.value)}
//                     InputProps={{
//                       sx: {
//                         textarea: {
//                           height: "60px",
//                           overflowY: "auto",
//                           resize: "none"
//                         }
//                       }
//                     }}
//                   />
//                 </Box>

//                 <button
//                   type="button"
//                   className="send-btn"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "6px",
//                     padding: "8px 16px",
//                     fontSize: "14px",
//                     fontWeight: 600,
//                     color: "#fff", // white text for red bg
//                     backgroundColor: "#f28b82", // light red
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                     width: "auto",
//                     overflow: "hidden",
//                     position: "relative",
//                     transition: "all 0.3s ease",
//                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
//                   }}
//                   onClick={() => document.getElementById("file-upload-input").click()}
//                   onMouseOver={(e) => {
//                     e.currentTarget.style.backgroundColor = "#d94f4f"; // darker red on hover
//                     e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
//                     const wave = e.currentTarget.querySelector(".hover-wave");
//                     if (wave) wave.style.left = "100%";
//                   }}
//                   onMouseOut={(e) => {
//                     e.currentTarget.style.backgroundColor = "#f28b82"; // revert to light red
//                     e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
//                     const wave = e.currentTarget.querySelector(".hover-wave");
//                     if (wave) wave.style.left = "-100%";
//                   }}
//                 >
//                   <FiPaperclip /> Attach files
//                   <span
//                     className="hover-wave"
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: "-100%",
//                       width: "100%",
//                       height: "100%",
//                       background: "rgba(255, 255, 255, 0.15)",
//                       transform: "skewX(-20deg)",
//                       transition: "left 0.6s ease-in-out",
//                       pointerEvents: "none",
//                     }}
//                   />
//                 </button>

//                 {/* Hidden File Input */}
//                 <input
//                   id="file-upload-input"
//                   type="file"
//                   hidden
//                   multiple
//                   onChange={handleFileChange}
//                 />
//                 {files.length > 0 && (
//                   <Box sx={{ mt: 1 }}>
//                     {files.map((file, index) => (
//                       <Paper
//                         key={index}
//                         variant="outlined"
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           p: 1,
//                           mb: 1
//                         }}
//                       >
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                           <Typography variant="body2">{file.name}</Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             ({Math.round(file.size / 1024)} KB)
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                           <CircularProgress size={16} />
//                           <IconButton size="small" onClick={() => removeFile(index)}>
//                             <FiX />
//                           </IconButton>
//                         </Box>
//                       </Paper>
//                     ))}
//                   </Box>
//                 )}


//                <button
//                     type="submit"
//                     disabled={loading}
//                     className={`send-btn ${loading ? "loading" : ""}`}
//                     style={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "6px",
//                       padding: "8px 16px",
//                       fontSize: "14px",
//                       fontWeight: 600,
//                       color: "#fff",
//                       backgroundColor: "#66bb6a", // light green
//                       border: "none",
//                       borderRadius: "8px",
//                       cursor: loading ? "not-allowed" : "pointer",
//                       opacity: loading ? 0.85 : 1,
//                       width: "auto",
//                       overflow: "hidden",
//                       position: "relative",
//                       transition: "all 0.3s ease",
//                       boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
//                     }}
//                     onMouseOver={(e) => {
//                       if (!loading) {
//                         e.currentTarget.style.backgroundColor = "#43a047"; // darker green on hover
//                         e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
//                         const wave = e.currentTarget.querySelector(".hover-wave");
//                         if (wave) wave.style.left = "100%";
//                       }
//                     }}
//                     onMouseOut={(e) => {
//                       if (!loading) {
//                         e.currentTarget.style.backgroundColor = "#66bb6a"; // revert to light green
//                         e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
//                         const wave = e.currentTarget.querySelector(".hover-wave");
//                         if (wave) wave.style.left = "-100%";
//                       }
//                     }}
//                   >
//                     {loading ? "SENDING" : <>SEND MESSAGE <FiSend /></>}
//                     <span
//                       className="hover-wave"
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: "-100%",
//                         width: "100%",
//                         height: "100%",
//                         background: "rgba(255, 255, 255, 0.15)",
//                         transform: "skewX(-20deg)",
//                         transition: "left 0.6s ease-in-out",
//                         pointerEvents: "none",
//                       }}
//                     />
//                   </button>


//                {error && (
//         <div className="alert success">
//           <FiCheckCircle className="icon" /> Message sent successfully!
//         </div>
//       )}

//       {successMessage && (
//         <div className="alert success">
//           <FiCheckCircle className="icon" /> {successMessage}
//         </div>
//       )}
//               </form>
//             </div>
//           </div>

//         </Box>
//       </Box>

//       <Footer />
//     </Box>

//   );
// };

// export default SendMessage;







//////////////////////////////////////////////////////////////////////////
























import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import Spinner from "../common/Spinner";
import { FaPaperPlane } from "react-icons/fa";
import {
  FiSend,
  FiPaperclip,
  FiX,
  FiCheckCircle,
  FiUsers,
  FiType,
  FiMessageSquare
} from "react-icons/fi";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  IconButton,
  CircularProgress
} from "@mui/material";
import { FaUserFriends, FaHeading, FaRegCommentDots } from "react-icons/fa";
import composemail from '../../Assets/emailcompose.png'

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SendMessage = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const ALLOWED_ATTACHMENT_MIME_TYPES = new Set([
    "application/pdf",
    "text/plain",
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "image/jpeg",
    "image/png",
    "image/gif",
    "application/zip",
    "application/x-zip-compressed",
  ]);
  const MAX_ATTACHMENTS = 5;
  const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) throw new Error("No authentication token found");

        const response = await fetch(`${BASE_URL}/api/employees`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message || "Failed to fetch employee data");
        }

        const data = await response.json();
        const employeeData = data.map((emp) => ({
          value: emp.email,
          label: `${emp.name} (${emp.email})`,
        }));

        const allOption = { value: "all", label: "Select All" };
        setEmployeeOptions([allOption, ...employeeData]);
      } catch (err) {
        setError(err.message || "Failed to fetch employee data");
      }
    };

    fetchEmployees();
  }, []);

  const handleEmployeeSelect = (selected = []) => {
    if (!selected || selected.length === 0) {
      setSelectedEmployees([]);
      return;
    }
    if (selected.some((opt) => opt.value === "all")) {
      setSelectedEmployees(
        employeeOptions.filter((opt) => opt.value !== "all")
      );
    } else {
      setSelectedEmployees(selected.filter((opt) => opt.value !== "all"));
    }
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (selectedFiles.length === 0) return;

    if (selectedFiles.length > MAX_ATTACHMENTS) {
      setError(`You can upload maximum ${MAX_ATTACHMENTS} attachments`);
      e.target.value = "";
      return;
    }

    const invalidType = selectedFiles.find(
      (file) => !ALLOWED_ATTACHMENT_MIME_TYPES.has(file.type)
    );
    if (invalidType) {
      setError(
        "Unsupported attachment type. Allowed: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, CSV, JPG, PNG, GIF, ZIP"
      );
      e.target.value = "";
      return;
    }

    const oversizedFile = selectedFiles.find(
      (file) => file.size > MAX_ATTACHMENT_SIZE_BYTES
    );
    if (oversizedFile) {
      setError(`Each attachment must be 10MB or smaller`);
      e.target.value = "";
      return;
    }

    setError("");
    setFiles(selectedFiles);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setLoading(true);

    try {
      const token = sessionStorage.getItem("token");
      if (!token) throw new Error("Authentication token not found");

      const receiverEmails = selectedEmployees.map((emp) => emp.value);
      if (receiverEmails.length === 0)
        throw new Error("Please select at least one receiver email");

      const formData = new FormData();
      formData.append("subject", subject);
      formData.append("message", message);
      receiverEmails.forEach((email) => formData.append("receiverEmail", email));
      files.forEach((file) => formData.append("files", file));

      // Log formData contents for debugging
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${BASE_URL}/api/mailmessage/sendMessage`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || "Failed to send the message");
      }

      setSuccessMessage("Email sent successfully with attachments");
      setSubject("");
      setMessage("");
      setFiles([]);
      setSelectedEmployees([]);
      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (err) {
      console.error("Error sending message:", err);
      setError(err.message || "Failed to send the message");
    } finally {
      setLoading(false);
    }
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const IconWrapper = ({ children }) => (
    <Box
      sx={{
        p: 0.5,
        border: "1px solid black",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 32,
        minHeight: 32
      }}
    >
      {children}
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "#F8FAFC" }}>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Header */}
      <Box sx={{ p: 3, mt: 6, ml: { md: "240px", xs: "10px" } }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Compose Mail
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Draft and send messages to employees with attachments and formatting.
        </Typography>
      </Box>

      {/* Main Content with Two Sections */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          // flexDirection: { xs: "column", md: "row" },
          flexDirection: { xs: "column-reverse", md: "row" },
          gap: { xs: 3, md: 0 }, // <-- add gap of 3 (theme spacing) on mobile, no gap on desktop
          p: 3.5,
          mt: 0,
          mb: 20,
          pl: { md: 33 }
        }}
      >
        {/* Left Side (40%) */}
        <Box
          sx={{
            flex: "0 0 40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "center",
            p: 3,
            pt: 2,
            alignSelf: "flex-start",
            minHeight: 540,
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
            bgcolor: "#ffffff",
            width: { xs: "100%", sm: "auto" }, // <-- here is the change
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 10,
              mt: 0 // optional: small top margin so it's not too close to the edge
            }}
          >
            Compose Mail
          </Typography>

          <Box
            component="img"
            src={composemail}
            alt="Mail Illustration"
            sx={{
              maxWidth: 190,
              height: "auto",
              mb: 11
            }}
          />

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 240, mb: 4, fontWeight: 600 }}
          >

            View and manage your inbox messages quickly and efficiently.
          </Typography>

        <Box
  sx={{
    display: "flex",
    gap: 1,
    mt: 2,
    width: "100%",
  }}
>
  {[
    { label: "Inbox", path: "/MyMessages" },
    { label: "Sent Mail", path: "/MySentMessages" },
  ].map((btn, index) => (
    <button
      key={index}
      type="button"
      style={{
        flex: 1, // equal width for both buttons
        backgroundColor: "#4fc3f7",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "15px",
        fontWeight: "600",
        fontFamily: "'Poppins', sans-serif",
        borderRadius: "8px",
        cursor: "pointer",
        overflow: "hidden",
        position: "relative",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
      }}
      onClick={() => navigate(btn.path)}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = "#0288d1";
        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
        const wave = e.currentTarget.querySelector(".hover-wave");
        if (wave) wave.style.left = "100%";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = "#4fc3f7";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
        const wave = e.currentTarget.querySelector(".hover-wave");
        if (wave) wave.style.left = "-100%";
      }}
    >
      {btn.label}
      <span
        className="hover-wave"
        style={{
          position: "absolute",
          top: 0,
          left: "-100%",
          width: "100%",
          height: "100%",
          background: "rgba(255, 255, 255, 0.15)",
          transform: "skewX(-20deg)",
          transition: "left 0.6s ease-in-out",
          pointerEvents: "none",
        }}
      />
    </button>
  ))}
</Box>


        </Box>




        {/* Right Side (60%) - Your Current Compose Form */}
        <Box sx={{ flex: "0 0 60%", pl: { md: 3, xs: 0 }, mt: { xs: 2, md: 0 }, }}>



          <Paper
            elevation={3}
            sx={{
              width: "100%",
              // maxWidth: 900, // increased from 650 to 900
              // borderRadius: 2,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              // bgcolor: "#fff",
              borderRadius: "16px", // same as the rest
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
              bgcolor: "#ffffff", // white like cards
            }}
          >



            {/* Header */}
            {/* import { FaPaperPlane } from "react-icons/fa"; */}

            {/* Header */}
            <Box
              sx={{
                p: 1.5,
                borderBottom: "1px solid #e0e0e0",
                bgcolor: "grey.50",
                display: "flex",
                alignItems: "center",
                gap: 1
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: "text.primary",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                Compose New Message
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 22,
                    height: 22,
                    border: "2px solid black", // black border
                    borderRadius: "50%",
                    backgroundColor: "transparent", // no background
                    color: "black", // black icon
                    padding: "2px"
                  }}
                >
                  <FaPaperPlane size={12} />
                </Box>
              </Typography>
            </Box>



            {/* Form */}
            <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
              {/* To */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <IconWrapper><FaUserFriends size={16} /></IconWrapper>
                <Box sx={{ flex: 1 }}>
                  <Select
                    isMulti
                    value={selectedEmployees}
                    onChange={handleEmployeeSelect}
                    options={employeeOptions}
                    placeholder="Recipients..."
                    classNamePrefix="select"
                    noOptionsMessage={() => "No employees found"}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isClearable
                    menuPlacement="bottom"
                    maxMenuHeight={240}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        border: state.isFocused
                          ? "1.5px solid #667eea"
                          : "1px solid #eef0f6",
                        boxShadow: "none",
                        minHeight: "40px",
                        borderRadius: 8,
                        padding: "2px 4px",
                        fontSize: "0.875rem",
                        backgroundColor: "#fff",
                        "&:hover": { borderColor: "#8b8fa3" },
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: "#8b8fa3",
                        padding: "6px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 2200,
                      }),
                      menu: (base) => ({
                        ...base,
                        border: "1px solid #eef0f6",
                        borderRadius: 8,
                        marginTop: 4,
                        zIndex: 2200,
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: 240,
                        overflowY: "auto",
                        paddingTop: 4,
                        paddingBottom: 4,
                      }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? "#EBF0FF"
                          : isFocused
                          ? "#f5f7fb"
                          : "transparent",
                        color: "#1a1a2e",
                        padding: "9px 12px",
                        minHeight: 40,
                        borderRadius: 4,
                        cursor: "pointer",
                        fontSize: "0.875rem",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#EBF0FF",
                        borderRadius: 6,
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: "#1a1a2e",
                        fontSize: "0.8125rem",
                      }),
                    }}
                  />
                </Box>
              </Box>

              {/* Subject */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <IconWrapper><FaHeading size={16} /></IconWrapper>
                <TextField
                  variant="standard"
                  fullWidth
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </Box>

              {/* Message */}
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }}>
                <IconWrapper><FaRegCommentDots size={16} /></IconWrapper>
                <TextField
                  variant="standard"
                  fullWidth
                  multiline
                  minRows={2}
                  placeholder="Message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  InputProps={{
                    sx: {
                      textarea: {
                        height: "60px",
                        overflowY: "auto",
                        resize: "none"
                      }
                    }
                  }}
                />
              </Box>




              {/* Alerts */}
              {/* {error && (
                <Alert sx={{ mb: 2 }} severity="error" icon={<FiX />}>
                  {error}
                </Alert>
              )}
              {successMessage && (
                <Alert sx={{ mb: 2 }} severity="success" icon={<FiCheckCircle />}>
                  {successMessage}
                </Alert>
              )} */}

              {error && (
                <div className="alert success">
                  <FiCheckCircle className="icon" /> Message sent successfully!
                </div>
              )}

              {successMessage && (
                <div className="alert success">
                  <FiCheckCircle className="icon" /> {successMessage}
                </div>
              )}

              <Box
                sx={{
                  // borderTop: "1px solid #e0e0e0",
                  pt: 1
                }}
              >
                {/* Buttons Row */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 1
                  }}
                >

                  <button
                    type="button"
                    className="send-btn"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#fff", // white text for red bg
                      backgroundColor: "#f28b82", // light red
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      width: "auto",
                      overflow: "hidden",
                      position: "relative",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                    }}
                    onClick={() => document.getElementById("file-upload-input").click()}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#d94f4f"; // darker red on hover
                      e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
                      const wave = e.currentTarget.querySelector(".hover-wave");
                      if (wave) wave.style.left = "100%";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#f28b82"; // revert to light red
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
                      const wave = e.currentTarget.querySelector(".hover-wave");
                      if (wave) wave.style.left = "-100%";
                    }}
                  >
                    <FiPaperclip /> Attach files
                    <span
                      className="hover-wave"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "-100%",
                        width: "100%",
                        height: "100%",
                        background: "rgba(255, 255, 255, 0.15)",
                        transform: "skewX(-20deg)",
                        transition: "left 0.6s ease-in-out",
                        pointerEvents: "none",
                      }}
                    />
                  </button>

                  {/* Hidden File Input */}
                  <input
                    id="file-upload-input"
                    type="file"
                    hidden
                    multiple
                    accept=".pdf,.txt,.csv,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.zip,application/pdf,text/plain,text/csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,image/jpeg,image/png,image/gif,application/zip,application/x-zip-compressed"
                    onChange={handleFileChange}
                  />
                  <Typography sx={{ mt: 1, fontSize: "12px", color: "#64748B" }}>
                    Allowed: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, CSV, JPG, PNG, GIF, ZIP | Max 5 files | Max 10MB each
                  </Typography>


                  <button
                    type="submit"
                    disabled={loading}
                    className={`send-btn ${loading ? "loading" : ""}`}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#fff",
                      backgroundColor: "#1E40AF",
                      border: "none",
                      borderRadius: "8px",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.85 : 1,
                      width: "auto",
                      overflow: "hidden",
                      position: "relative",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                    }}
                    onMouseOver={(e) => {
                      if (!loading) {
                        e.currentTarget.style.backgroundColor = "#152D85";
                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
                        const wave = e.currentTarget.querySelector(".hover-wave");
                        if (wave) wave.style.left = "100%";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!loading) {
                        e.currentTarget.style.backgroundColor = "#1E40AF";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
                        const wave = e.currentTarget.querySelector(".hover-wave");
                        if (wave) wave.style.left = "-100%";
                      }
                    }}
                  >
                    {loading ? "SENDING" : <>SEND MESSAGE <FiSend /></>}
                    <span
                      className="hover-wave"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "-100%",
                        width: "100%",
                        height: "100%",
                        background: "rgba(255, 255, 255, 0.15)",
                        transform: "skewX(-20deg)",
                        transition: "left 0.6s ease-in-out",
                        pointerEvents: "none",
                      }}
                    />
                  </button>


                </Box>

                {/* File List Row (always below buttons) */}
                {files.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    {files.map((file, index) => (
                      <Paper
                        key={index}
                        variant="outlined"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          p: 1,
                          mb: 1
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography variant="body2">{file.name}</Typography>
                          <Typography variant="caption" color="text.secondary">
                            ({Math.round(file.size / 1024)} KB)
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CircularProgress size={16} />
                          <IconButton size="small" onClick={() => removeFile(index)}>
                            <FiX />
                          </IconButton>
                        </Box>
                      </Paper>
                    ))}
                  </Box>
                )}

                {/* Styles */}
                <style>
                  {`
      .send-btn:hover:not(:disabled) {
        background: #1765c1;
        transition: background 0.3s ease;
      }
      .send-btn.loading {
        background: repeating-linear-gradient(
          45deg,
          #1a73e8,
          #1a73e8 10px,
          #1669c1 10px,
          #1669c1 20px
        );
        background-size: 40px 40px;
        animation: stripeMove 1s linear infinite;
      }
      @keyframes stripeMove {
        from { background-position: 0 0; }
        to { background-position: 40px 0; }
      }
    `}
                </style>
              </Box>




            </Box>
          </Paper>

        </Box>
      </Box>

      <Footer />
    </Box>

  );
};

export default SendMessage;
